import { FC, ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { useCurrentUser } from '@hooks/users';
import { isUserSubscribed } from '@helpers';

interface RequireUnsubscribedProps {
  children: ReactNode;
  redirectTo?: string;
}

export const RequireUnsubscribed: FC<RequireUnsubscribedProps> = ({
  children,
  redirectTo = '/',
}) => {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading || !user) {
    return null;
  }

  if (isUserSubscribed(user)) {
    return <Navigate to={redirectTo} />;
  }

  return <>{children}</>;
};
